import { create } from 'zustand'

import { FetchAppMenuResponseInterface } from 'src/types/AppMenuInterface'
import { ReactCallBackFunction } from 'src/types/CallbackFunction'

interface MenuState {
  menus: FetchAppMenuResponseInterface
  setMenus: ReactCallBackFunction<{
    menus: FetchAppMenuResponseInterface
    loading: boolean
    error: Error | null
  }>
  loading: boolean
  error: Error | null
}

const useMenusStore = create<MenuState>(set => ({
  menus: [],
  setMenus: args =>
    set(state => {
      if (typeof args === 'function') {
        return {
          ...state,
          ...args(state),
        }
      }
      return {
        menus: args.menus,
        loading: args.loading,
        error: args.error,
      }
    }),
  loading: false,
  error: null,
}))

export default useMenusStore
